module.exports = __webpack_public_path__ + "assets/img/juanzhou.b7f56931.png";